import { parsePreview, PreviewRow } from "./preview";

const ignore = () => {};

/** A bounded, non-interactive document thumbnail; never mounts an editor. */
export function MarkdownThumbnail({ markdown }: { markdown: string }) {
  const excerpt = markdown.slice(0, 6000).split("\n").slice(0, 40).join("\n");
  return (
    <div
      inert
      aria-hidden="true"
      className="pointer-events-none h-full overflow-hidden text-xs leading-relaxed break-words whitespace-pre-wrap [mask-image:linear-gradient(to_bottom,black_78%,transparent)] [&_img]:max-h-36 [&_img]:w-full [&_img]:object-cover [&_[data-markdown-line]]:text-[inherit] [&_[data-markdown-line]]:leading-relaxed [&_[data-markdown-line]]:tracking-normal [&_[data-markdown-line][data-heading='1']]:text-base [&_[data-markdown-line][data-heading='2']]:text-sm"
    >
      {excerpt.trim() ? (
        parsePreview(excerpt).map((line) => (
          <PreviewRow key={line.from} line={line} reveal={false} onTask={ignore} onLink={ignore} />
        ))
      ) : (
        <span className="text-fg-faint">An empty page, ready for an idea.</span>
      )}
    </div>
  );
}
